"use client"

import { ROLES } from "@prisma/client";
import { useSession } from "next-auth/react";
// import { auth } from "~/server/auth";

export const useClientAuth = () => {
  const session = useSession();

  const isAuth = session.status === "authenticated";
  const isUser = session.data?.user ?? null;
  const isAdmin = session.data?.user?.role as ROLES === ROLES.admin;

  return { isAuth, isUser, isAdmin };
};

// export const useServerAuth = async () => {
//   const session = await auth();
//   const isAuth = session?.status === "authenticated";
//   const isUser = session?.data?.user ?? null as Session;

//   return { isAuth, isUser };
// }